// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".form-group{margin:3.2rem 0 0}._1bvlr .input-container:before{content:\"+\";font-size:14px;font-size:1.4rem;height:calc(1.375em + 1.4rem + 2px);opacity:.7;padding-left:6px;padding-top:10px;position:absolute}", ""]);
// Exports
exports.locals = {
	"callingCode": "_1bvlr"
};
module.exports = exports;
